<div class="p-10">
  <div class="absolute right-4 top-4 cursor-pointer">
    <mat-icon
      tabindex="0"
      class="material-icons-outlined hvs-icon-lg shrink-0"
      (click)="onCloseBtnClick()"
      (keydown.enter)="onCloseBtnClick()"
    >
      close
    </mat-icon>
  </div>
  <p class="text-2xl font-semibold text-blue-dark">
    {{ 'portal.courses.previewDialog.title' | transloco }}
  </p>
  <p class="mt-2 text-base font-normal text-grey">
    {{ 'portal.courses.previewDialog.description' | transloco }}
  </p>
  <div
    class="relative mt-8 aspect-[16/9] overflow-hidden rounded-xl border-4 border-blue-light"
  >
    <iframe
      id="course-preview-id"
      [src]="safeUrl"
      class="absolute left-0 top-0 size-full"
      allow="fullscreen"
      sandbox="allow-forms allow-modals allow-scripts allow-same-origin"
    ></iframe>
  </div>
</div>
